import React from 'react';
import { Image as RNImage, ImageProps as RNImageProps } from 'react-native';

// expo-imageのPropsとの互換性のための簡易定義
export type ImageProps = RNImageProps & {
  contentFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  transition?: number;
};

export const Image: React.FC<ImageProps> = ({ contentFit, transition, ...props }) => {
  // react-nativeのImageはresizeModeを使用する
  const resizeMode = contentFit === 'cover' ? 'cover' : 
                     contentFit === 'contain' ? 'contain' :
                     contentFit === 'fill' ? 'stretch' : 
                     contentFit === 'none' ? 'center' : 'contain';

  return <RNImage {...props} resizeMode={resizeMode} />;
};
